import {
    FETCH_STATUS_SUCCESS, FETCH_STATUS_FAILURE,
    FETCH_CURRENT_SUCCESS, FETCH_CURRENT_FAILURE,
    ACCEPT_TERMS, ACCEPT_TERMS_SUCCESS, ACCEPT_TERMS_FAILURE,
} from './TermsActionTypes'

export const initialTermsState = () => ({
    currentDocument: null,
    status: null,
    accepting: false,
    error: null,
});

const terms = (state = initialTermsState(), action) => {
    switch (action.type) {
        case FETCH_STATUS_SUCCESS:
            return {
                ...state,
                status: action.status,
            }
        case FETCH_STATUS_FAILURE:
            return {
                ...state,
                error: "Kunde inte hämta status för användarvillkor",
            }
        case FETCH_CURRENT_SUCCESS:
            return {
                ...state,
                currentDocument: action.currentDocument,
            }
        case FETCH_CURRENT_FAILURE:
            return {
                ...state,
                error: "Kunde inte hämta användarvillkor",
            }
        case ACCEPT_TERMS:
            return {
                ...state,
                accepting: true,
                error: null,
            }
        case ACCEPT_TERMS_SUCCESS:
            return {
                ...state,
                accepting: false,
                error: null,
            }
        case ACCEPT_TERMS_FAILURE:
            return {
                ...state,
                accepting: false,
                error: "Kunde inte spara godkännandet, försök igen",
            }
        default:
            return state;
    }
}
export default terms;
